<a href="https://www.youtube.com/@quizzaro_com"
    ><span><img src="../../../assets/image/youtube.png" alt="youtube icon" srcset="" /></span
></a>
